/* eslint-disable */
// Ortak dashboard yardımcıları (parse / serialize / type mapping)
// 11 kaldırıldı; 12/13/14 kullanılır
export const SAVE_DASHBOARD_TYPE_MAP = { operational: 12, brand: 13, mt: 14 };
export const DASHBOARD_TYPE_TO_KEY = Object.fromEntries(
  Object.entries(SAVE_DASHBOARD_TYPE_MAP).map(([k, v]) => [v, k])
);

// Sayfa anahtarını normalize et (12|13|14 veya string)
export function pageKeyFor(t) {
  if (typeof t === 'string' && t) return SAVE_DASHBOARD_TYPE_MAP[t] ? t : 'operational';
  const n = Number(t);
  return DASHBOARD_TYPE_TO_KEY[n] || 'operational';
}

// String (operational/brand/mt) veya number (12/13/14) -> number döndürür
export function resolveType(rawType/*, _mode */){
  if (typeof rawType === 'number') return [12,13,14].includes(rawType) ? rawType : 12;
  if (typeof rawType === 'string') return SAVE_DASHBOARD_TYPE_MAP[rawType] ?? 12;
  return 12;
}

// Frontend detail -> backend configuration (düz şema)
export function serialize(detail, panelId){
  if(!detail || !detail.layout) return null;
  const { layout, widgets } = detail;
  const byCols = typeof layout.cols === 'number' ? layout.cols : null;
  const rawStruct = layout?.structure ? String(layout.structure) : '';
  let structure = '1';
  if (byCols && byCols >= 1 && byCols <= 3) structure = String(byCols);
  else if (/^\d+$/.test(rawStruct)) structure = String(Math.max(1, Math.min(3, Number(rawStruct))));

  const flat = (widgets||[])
    .filter(w => w && w.id)
    .sort((a,b) => (a.slotIndex??a.position??0) - (b.slotIndex??b.position??0))
    .map(w => ({ 
      id: w.id, 
      type: w.type, 
      title: w.title, 
      // Two-title model persisted for each widget
      widgetTitle: w.widgetTitle || w.title || w.type,
      chartTitle: w.chartTitle || w.title || w.type,
      slotIndex: (w.slotIndex ?? w.position ?? 0), 
      config: { ...(w.config||{}) },
      // Widget metadata'larını da kaydet
      ...(w.widgetId && { widgetId: w.widgetId }),
      ...(w.endpoint && { endpoint: w.endpoint }),
      ...(w.param && { param: w.param }),
      ...(w.chartType && { chartType: w.chartType }),
      ...(w.icon && { icon: w.icon }),
      ...(w.component && { component: w.component }),
      ...(w.dialogType && { dialogType: w.dialogType }),
      ...(w.settingsDialog !== undefined && { settingsDialog: w.settingsDialog }),
      ...(w.widgetType && { widgetType: w.widgetType }),
      ...(w.dashboardType && { dashboardType: w.dashboardType }),
      ...(w.paramStrategy && { paramStrategy: w.paramStrategy }),
      ...(w.description && { description: w.description })
    }));

  return { version: layout.version || 1, panelId: panelId || (widgets?.[0]?.dashboardId) || null, structure, widgets: flat };
}

// Backend configuration -> frontend detail
export function parse(detail, dashboardId){
  if(!detail?.configuration) return null;
  const conf = typeof detail.configuration==='string' ? JSON.parse(detail.configuration) : detail.configuration;
  if(!conf) return null;
  const cols = (/^\d+$/.test(String(conf.structure||'')) ? Math.max(1, Math.min(3, Number(conf.structure))) : 1);
  const columns = Array.from({ length: cols }).map(() => ({ widgetIds: [] }));
  const list = [];
  if (Array.isArray(conf.widgets)) {
    [...conf.widgets]
      .filter(w=>w && w.id)
      .sort((a,b)=> (a.slotIndex??0)-(b.slotIndex??0))
      .forEach((w,i)=>{
        const idx = Number(w.slotIndex ?? i);
        const cI = cols > 0 ? (idx % cols) : 0;
        const rI = cols > 0 ? Math.floor(idx / cols) : idx;
        const colRef = columns[cI];
        while (colRef.widgetIds.length <= rI) colRef.widgetIds.push(null);
        colRef.widgetIds[rI] = w.id;
        list.push({ 
          id: w.id, 
          type: w.type, 
          title: w.title || w.type, 
          // Populate two-title model with fallbacks for backward compatibility
          widgetTitle: w.widgetTitle || w.title || w.type,
          chartTitle: w.chartTitle || w.title || w.type,
          position: idx, 
          slotIndex: idx, 
          row: 0, 
          col: cI, 
          orderInColumn: rI, 
          dashboardId, 
          config: { ...(w.config||{}) }, 
          data: w.data || {},
          persistId: w.id,
          // Widget metadata'larını da yükle
          ...(w.widgetId && { widgetId: w.widgetId }),
          ...(w.endpoint && { endpoint: w.endpoint }),
          ...(w.param && { param: w.param }),
          ...(w.chartType && { chartType: w.chartType }),
          ...(w.icon && { icon: w.icon }),
          ...(w.component && { component: w.component }),
          ...(w.dialogType && { dialogType: w.dialogType }),
          ...(w.settingsDialog !== undefined && { settingsDialog: w.settingsDialog }),
          ...(w.widgetType && { widgetType: w.widgetType }),
          ...(w.dashboardType && { dashboardType: w.dashboardType }),
          ...(w.paramStrategy && { paramStrategy: w.paramStrategy }),
          ...(w.description && { description: w.description })
        });
      });
  }
  return { layout: { structure: String(cols), rows: [ { columns } ], version: conf.version || 1 }, widgets: list, raw: detail };
}

// Panel detail yoksa varsayılan üret
export function ensurePanelDetail(state, panelId, pageType){
  const exist = state.panelDetails?.[panelId];
  if (exist) return exist;
  const key = pageKeyFor(pageType);
  const layout = state.dashboardLayouts?.[key];
  const widgets = state.pageWidgets?.[key] || [];
  const clone = (o) => JSON.parse(JSON.stringify(o));
  return { layout: clone(layout || { structure:'1', rows:[ { columns:[ { widgetIds:[] } ] } ], version:1 }), widgets: clone(widgets), raw:{} };
}

export default { resolveType, pageKeyFor, serialize, parse, ensurePanelDetail, SAVE_DASHBOARD_TYPE_MAP, DASHBOARD_TYPE_TO_KEY };
